import React, { useState, useRef, useEffect } from 'react'

import { Carousel as CarouselComp } from 'react-responsive-carousel'
import styled from 'styled-components'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { useEventListener, useWindowSize } from '../../../_helpers'
import {
    devices,
    colors,
    CarouselNext,
    CarouselPrev,
    Title,
    ThumbnailsIcon,
} from '../../Common'


export const SimpleCarousel = ({ slides, title, close, activeImage }) => {
    const [activeSlide, setActiveSlide] = useState(activeImage)
    const [carouselWidth, setCarouselWidth] = useState(0)
    // const [videoModal, setVideoModal] = useState(false)
    // const [videoUrl, setVideoUrl] = useState('')
    // const [height, setHeight] = useState('')
    const carousel = useRef()
    const { width } = useWindowSize()
    const mobile = width < 480

    const handleChange = id => setActiveSlide(id)

    // const openVideoModal = video_url => {
    //     setVideoModal(true)
    //     setVideoUrl(video_url)
    // }

    // const closeVideoModal = () => setVideoModal(false)

    const next = () => setActiveSlide(activeSlide + 1)
    const prev = () => setActiveSlide(activeSlide - 1)

    const updateDimensions = () => {
        const width = carousel.current.offsetWidth
        setCarouselWidth(width)
    }

    useEffect(() => {
        updateDimensions()
    }, [])

    useEventListener('resize', updateDimensions)

    return (
        <CarouselContainer ref={carousel}>
            <CarouselFlex>
                <CarouselPrev onClick={prev} role='button' aria-label='Previous slide' />
                <div style={{ flex: '1 0 33%' }}>
                    <Title fontSize={mobile ? 14 : 16}>{title}</Title>
                    <StyledCarousel
                        showStatus={false}
                        showArrows={false}
                        showThumbs={false}
                        showIndicators={false}
                        infiniteLoop={slides.length > 1}
                        stopOnHover={false}
                        interval={5000}
                        transitionTime={800}
                        autoPlay={false}
                        selectedItem={activeSlide}
                        onChange={handleChange}
                        carouselwidth={carouselWidth}
                    >

                        {slides.map(img =>
                            <div key={img.image}>
                                <SlideImageCard
                                    background={img.image}
                                    alt={img.alt_text}
                                    // orientation={img.orientation === 'portrait' ? 'contain' : 'cover'}
                                />
                                {img.author && <Caption>{img.author}</Caption>}
                            </div>
                        )}
                    </StyledCarousel>
                    <ThumbnailButton onClick={close}>
                        <ThumbnailsIcon />
                        Show Thumbnails
                    </ThumbnailButton>
                </div>
                <CarouselNext onClick={next} role='button' aria-label='Next slide' />
            </CarouselFlex>
        </CarouselContainer>
    )
}

const ThumbnailButton = styled.div`
    margin-top: 20px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${colors.white};
    font-weight: 900;
    font-size: 12px;
    /* width: fit-content; */
    position: absolute;
    cursor: pointer;
`

const CarouselContainer = styled.div`
    margin-bottom: 30px;
    position: relative;

    @media ${devices.small} {
        height: 100%;
        display: flex;
        align-items: center;
    }
`

const StyledCarousel = styled(CarouselComp)`
    flex: 1 0 33%;

    @media ${devices.small} {
        width: ${({ carouselwidth }) => carouselwidth}px;
    }

    .slide {
        background: transparent;
        /* @media ${devices.small} {
            height: 210px;
        } */
    }

    && {
        .control-dots {
            display: none;
        }
    }
`

export const VideoThumbnail = styled.div`
    height: ${({ height }) => height}px;
    background: url(${({ image }) => image});
    background-position: center;
    background-size: cover;
    cursor: pointer;
    // margin-bottom: 30px;

    @media ${devices.small} {
        height: 210px;
    }
`

export const VideoPlayButton = styled.div`
    height: 55px;
    width: 47px;
    background: url(/static/images/sprite.svg) -1px -570px;
    cursor: pointer;
`

const ImageCard = styled.div`
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background: url(${props => props.background}) no-repeat 50% 50%/cover;
`

const SlideImageCard = styled(ImageCard)`
    margin-bottom: 0;
    background-position: top;
    border: 10px solid white;
    position: relative;
    @media ${devices.small} {
        border-width: 3px;
    }
`

const CarouselFlex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    @media ${devices.small} {
        margin-bottom: ${({ lightbox }) => lightbox ? '20' : '0'}px;
    }
`

const Caption = styled.div`
    font-size: 14px;
    text-align: end;
    margin-top: 10px;
    color: ${colors.white};
    text-transform: uppercase;
    position: absolute;
    right: 0;
`
